<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：国家文物局博物馆与社会文物司）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入藏品名称/普查登记号/收藏单位"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <div>
              <el-select
                v-model="category"
                clearable
                placeholder="类别"
                class="category"
                @change="categoryChange()"
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="years"
                clearable
                placeholder="年代"
                class="years"
                @change="yearsChange()"
              >
                <el-option
                  v-for="item in yearsList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <!-- <el-cascader
                class="options"
                :options="options"
                clearable
                placeholder="年代"
              ></el-cascader> -->
            </div>
            <div class="card">
              <el-radio v-model="radio" @change="company()" label="1"
                >按单位名称排序</el-radio
              >
              <el-radio v-model="radio" @change="collection()" label="2"
                >按藏品名称排序</el-radio
              >
            </div>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            v-loading="loading"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="registerNum"
              label="普查登记号"
              min-width="220px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="crName"
              label="藏品名称"
              min-width="256px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="crClassName"
              label="藏品类别"
              min-width="146px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="ccrAgeName"
              label="藏品年代"
              min-width="182px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="collectionName"
              label="收藏单位"
              min-width="200px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_PRECIOUS_CULTURAL_RELICS,
  URL_COMPREHENSIVE_EXCUSE,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";

export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      loading: false,
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "",
        // 浏览次数
        num: "2",
      },
      // 年代
      yearsList: [],
      // 年代
      years: null,
      // 类别
      categoryList: [],
      // 类别
      category: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      //   单选按钮
      radio: "1",
      pagesize: 10,
      sign: 1,
    };
  },
  computed: {},
  methods: {
    // 请求列表数据
    getList() {
      this.loading = true;
      let result = frontHeater(
        ["crClassCode", "ccrAgeCode"],
        [this.category, this.years]
      );
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        keyWord: this.searchOn,
        crClassCode: this.category,
        sort: { collectionName: "1" },
        ccrAgeCode: this.years,
        pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["crClassCode"] = this.category;
      this.$http.defaults.headers.common["ccrAgeCode"] = this.years;
      this.$http
        .post(Url + URL_PRECIOUS_CULTURAL_RELICS, params)
        .then((res) => {
          if (res.status == 200) {
            this.legalForms = res.data.data.data;
            this.total = res.data.data.recordsTotal;
            this.loading = false;
          }
        });
    },
    // 获取藏品排序列表
    getCollectionList() {
      let result = frontHeater(
        ["crClassCode", "ccrAgeCode"],
        [this.category, this.years]
      );
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        keyWord: this.searchOn,
        crClassCode: this.category,
        sort: { crName: "1" },
        ccrAgeCode: this.years,
        pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["crClassCode"] = this.category;
      this.$http.defaults.headers.common["ccrAgeCode"] = this.years;
      this.$http
        .post(Url + URL_PRECIOUS_CULTURAL_RELICS, params)
        .then((res) => {
          if (res.status == 200) {
            this.legalForms = res.data.data.data;
            this.total = res.data.data.recordsTotal;
          }
        });
    },
    // 获取类别
    getCategoryList() {
      let result = frontHeater(["ClassCode"], ["CrClassCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "CrClassCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "CrClassCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.categoryList = res.data.data;
        }
      });
    },
    // 获取年代
    getYearsList() {
      let result = frontHeater(["ClassCode"], ["CcrAgeCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "CcrAgeCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "CcrAgeCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.yearsList = res.data.data;
        }
      });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataCollectioncr"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataCollectioncr",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] = "DataCollectioncr";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 搜索
    seeSer() {
      if (this.sign == 1) {
        this.getList();
      }
      if (this.sign == 2) {
        this.getCollectionList();
      }
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.category = null;
      this.years = null;
      this.currentPage = 1;
      if (this.sign == 1) {
        this.getList();
      }
      if (this.sign == 2) {
        this.getCollectionList();
      }
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 表格分页
    handleSizeChange(val) {
      this.pagesize = val;
      if (this.sign == 1) {
        this.getList();
      }
      if (this.sign == 2) {
        this.getCollectionList();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.sign == 1) {
        this.getList();
      }
      if (this.sign == 2) {
        this.getCollectionList();
      }
    },
    // 类别改变
    categoryChange() {
      if (this.sign == 1) {
        this.getList();
      }
      if (this.sign == 2) {
        this.getCollectionList();
      }
    },
    // 年代改变
    yearsChange() {
      if (this.sign == 1) {
        this.getList();
      }
      if (this.sign == 2) {
        this.getCollectionList();
      }
    },
    // 点击单位排序
    company() {
      this.sign = 1;
      this.getList();
    },

    // 点击藏品排序
    collection() {
      this.sign = 2;
      this.getCollectionList();
    },
  },
  mounted() {
    if (this.sign == 1) {
      this.getList();
    }
    if (this.sign == 2) {
      this.getCollectionList();
    }
    this.regulations.laws = this.$route.query.title;
    this.getCategoryList();
    this.getYearsList();
    this.getNumberViews();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
/deep/ .el-breadcrumb {
  font-size: 16px;
}
/deep/ .el-input--suffix .el-input__inner {
  font-size: 16px;
}
/deep/ .el-button {
  font-size: 16px !important;
}
/deep/ .el-radio__label {
  font-size: 16px;
}
.refresh {
  height: 100%;
}
.paging {
  display: flex;
  width: 70rem;
  justify-content: space-between;
  align-items: center;
}
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.ipt {
  margin-top: 10px;
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.category {
  width: 150px;
}
.options {
  width: 200px;
}
.years {
  width: 150px;
}

.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  align-items: center;
}
/deep/ .el-loading-spinner .path {
  stroke: red;
}
</style>